module.exports = __webpack_public_path__ + "static/media/brinquedo1.e5986358.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo1.jpg
// module id = 57
// module chunks = 0